import { render, staticRenderFns } from "./DescriptionsPage.vue?vue&type=template&id=b75becac&"
import script from "./DescriptionsPage.vue?vue&type=script&lang=js&"
export * from "./DescriptionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports